module.exports = __webpack_public_path__ + "static/img/10.a33906a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/sp/10.png
// module id = el9t
// module chunks = 0